import { useAuthStore } from '../store/authStore';
import { canViewAllKanbanAssignees } from './rbac';

export const canViewAllTaskAssignees = (role: string | null): boolean =>
  canViewAllKanbanAssignees(role);

/** Default assignee filter: roles with view-all → all; others → logged-in user. */
export const getDefaultTaskAssigneeFilter = (): string => {
  const { role, staffUserId, user } = useAuthStore.getState();
  if (canViewAllTaskAssignees(role)) {
    return 'all';
  }
  const userId = staffUserId ?? user?.id;
  return userId ? String(userId) : 'all';
};
